module.exports = __webpack_public_path__ + "static/media/godaddy.81d67844.svg";